import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _get from "lodash/get";
var _excluded = ["className", "columns", "data", "hasTableHeader", "rowHover", "aria-label", "aria-labelledby"];
import "core-js/modules/es6.array.map.js";
import React from 'react';
import classNames from 'classnames';
import { wrapWithAlign } from './utils';
import styles from './TableSimple.module.less';
export var TableSimple = function TableSimple(_ref) {
  var className = _ref.className,
      columns = _ref.columns,
      data = _ref.data,
      _ref$hasTableHeader = _ref.hasTableHeader,
      hasTableHeader = _ref$hasTableHeader === void 0 ? true : _ref$hasTableHeader,
      rowHover = _ref.rowHover,
      ariaLabel = _ref['aria-label'],
      ariaLabelledBy = _ref['aria-labelledby'],
      otherProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("div", {
    className: classNames(styles.tableSimple, _defineProperty({}, styles.rowHover, rowHover), className)
  }, /*#__PURE__*/React.createElement("table", _extends({
    className: styles.table,
    "aria-label": ariaLabel,
    "aria-labelledby": ariaLabelledBy // All components need to be keyboard usable, `tabIndex="0"`
    // is a rare acceptable exception
    // https://dequeuniversity.com/rules/axe/3.5/scrollable-region-focusable?application=axeAPI
    // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
    ,
    tabIndex: 0
  }, otherProps), hasTableHeader && /*#__PURE__*/React.createElement("thead", {
    className: styles.thead
  }, /*#__PURE__*/React.createElement("tr", {
    className: styles.tr
  }, columns.map(function (_ref2) {
    var id = _ref2.id,
        minWidth = _ref2.minWidth,
        align = _ref2.align,
        heading = _ref2.heading;
    return /*#__PURE__*/React.createElement("th", {
      key: id,
      className: styles.th,
      style: typeof minWidth === 'number' ? {
        minWidth: minWidth
      } : undefined,
      scope: "col"
    }, wrapWithAlign(align !== null && align !== void 0 ? align : 'left', heading));
  }))), /*#__PURE__*/React.createElement("tbody", null, data.map(function (row) {
    return /*#__PURE__*/React.createElement("tr", {
      key: row.key,
      className: styles.tr
    }, columns.map(function (column) {
      return /*#__PURE__*/React.createElement("td", {
        className: styles.td,
        key: column.id
      }, wrapWithAlign(row.align || column.align, _get(row, column.id)));
    }));
  }))));
};
TableSimple.displayName = 'TableSimple';